import './support-materials.scss';
import Header from '../../components/header/header';
import TabsHome from '../../components/tabs-home/tabs-home';
import Sidebar from '../../components/sidebar/sidebar';
import SupportMaterialsService from '../../services/support-materials-service';
import { useState, useEffect, useRef } from 'react';
import { TEAM, SESSION } from '../../constants';
import LocalStorage from '../../services/local-storage';
import moment from 'moment';
import MATERIAL_AUDIO from '../../assets/material-audio.png';
import MATERIAL_PDF from '../../assets/material-pdf.png';
import MATERIAL_TEXT from '../../assets/material-text.png';
import TranslateService from '../../services/translate-service';
import EmptyState from '../../components/empty-state/empty-state';
import NO_LIKE from '../../assets/icon-no-like.svg';
import LIKE from '../../assets/icon-like.svg';

export default function SupportMaterials() {

    const firstUpdate = useRef(true);
    const [currentMaterial, setCurrentMaterial] = useState({ isOpen: false, material: null });
    const [team] = useState(LocalStorage.get(TEAM));
    const [session] = useState(LocalStorage.get(SESSION));
    const [materials, setMaterials] = useState({
        original: [],
        filtered: []
    });
    const [filters, setFilters] = useState([]);

    const getMaterials = async () => {
        try {
            const response = await SupportMaterialsService.get(team.area._id, session._id);

            setMaterials({ original: response, filtered: response });
        } catch (error) { }
    }

    const formatType = (type) => {
        
        switch (type) {
            case "VIDEO":
                return TranslateService.get('supportMaterials.type.video');
            case "IMAGEN":
                return TranslateService.get('supportMaterials.type.image');
            case "ARCHIVO":
                return TranslateService.get('supportMaterials.type.pdf');
            case "AUDIO":
                return TranslateService.get('supportMaterials.type.audio');
            case "TEXTO":
                return TranslateService.get('supportMaterials.type.text');

            default:
                return type;
        }
    }

    const thumbnail = (material) => {
        switch (material.tipo) {
            case "VIDEO":
                return material.thumbnail;
            case "IMAGEN":
                return material.url;
            case "ARCHIVO":
                return MATERIAL_PDF;
            case "AUDIO":
                return MATERIAL_AUDIO;
            case "TEXTO":
                return MATERIAL_TEXT;

            default:
                return 'https://via.placeholder.com/500x300';
        }
    }

    const handleSearch = term => {
        term = term || '';
        
        if(!term && !filters.length) {
            setMaterials({ original: materials.original, filtered: materials.original });
            return;
        }

        let filtered = [];
        if(filters.length) {
            filtered = materials.original.filter( material => 
                filters.indexOf(material.tipo) !== -1  && 
                (
                    material.titulo.match(new RegExp(`${term}`, 'i')) || 
                    material.descripcion.match(new RegExp(`${term}`, 'i')) 
                )
            ); 
        } else {
            filtered = materials.original.filter( material => 
                material.titulo.match(new RegExp(`${term}`, 'i')) || 
                material.descripcion.match(new RegExp(`${term}`, 'i')) 
            );
        }

        
        setMaterials({ original: materials.original, filtered: filtered });
    }

    const handleFilter = type => {
        if(type === 'ALL') {
            setFilters([]);
            return;
        }

        const exists = filters.find( f => f === type);

        if(exists) {
            setFilters(filters.filter(f => f !== type));
        } else {
            setFilters(filters.concat([type]));
        }
    }

    const handleLike = async (material) => {
        try {
            // setIsLiked(!isLiked)
            let meterials = [...materials.filtered];
            meterials.map( m => {
                if(m._id === material._id) {
                    m.like.status = !m.like.status;
                }

                return m;
            })
            
            setMaterials({ original: materials.original, filtered: meterials });

            await SupportMaterialsService.handleLike(team.area._id, session._id, material._id);
            
        } catch (error) {  }
    }

    const onCloseSidebar = () => {
        setCurrentMaterial({ isOpen: false, material: null })
        getMaterials()
    }


    useEffect(() => {
        if (firstUpdate.current) {
            firstUpdate.current = false;
            getMaterials();

            return;
        }
    });

    useEffect(() => {
        document.getElementsByTagName('body')[0].style.overflow = currentMaterial.isOpen ? 'hidden' : 'auto';
    }, [currentMaterial.isOpen]);

    useEffect( handleSearch, [filters]);  // eslint-disable-line react-hooks/exhaustive-deps

    return (
        <>
            {currentMaterial.isOpen &&
                <Sidebar material={currentMaterial.material} open={currentMaterial.isOpen} onClose={onCloseSidebar} />
            }


            <div className='support-materials'>
                <div className="bg-support-materials">
                    <Header />
                    <div className='bg-support-materials-waves pb-72  pt-7'>
                        <div className='container  mx-auto px-4'>
                            <TabsHome />

                            <div className='mt-12'>
                                <h1 className='heading-h1 text-center  !text-white mt-2 mb-5'>{TranslateService.get('supportMaterials.title')}</h1>

                                <div className='grid grid-cols-12 gap-4 m-auto'>
                                    <div className='col-span-6 col-start-4'>
                                        <input type='text' className='input-search' placeholder={TranslateService.get('supportMaterials.search')} onKeyUp={e => handleSearch(e.target.value)} />
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>

                </div>

                <div className='container mx-auto px-4 mt-[-190px] pb-10'>

                    <div className='flex  justify-center filters mb-4'>
                        <div onClick={() => handleFilter('ALL')} className={ !filters.length? 'active': ''}>{TranslateService.get('supportMaterials.filter.all')}</div>
                        <div onClick={() => handleFilter('VIDEO')} className={ filters.indexOf('VIDEO') !== -1? 'active': ''}>{TranslateService.get('supportMaterials.filter.video')}</div>
                        <div onClick={() => handleFilter('IMAGEN')} className={ filters.indexOf('IMAGEN') !== -1? 'active': ''}>{TranslateService.get('supportMaterials.filter.image')}</div>
                        <div onClick={() => handleFilter('ARCHIVO')} className={ filters.indexOf('ARCHIVO') !== -1? 'active': ''}>{TranslateService.get('supportMaterials.filter.pdf')}</div>
                        <div onClick={() => handleFilter('AUDIO')} className={ filters.indexOf('AUDIO') !== -1? 'active': ''}>{TranslateService.get('supportMaterials.filter.audio')}</div>
                        <div onClick={() => handleFilter('TEXTO')} className={ filters.indexOf('TEXTO') !== -1? 'active': ''}>{TranslateService.get('supportMaterials.filter.text')}</div>
                    </div>

                    <div className='grid grid-cols-12 gap-4'>
                        {!materials.original.length &&
                            <div className='col-span-8 col-start-3'>
                                <div className='card  text-center '>
                                    <EmptyState title={TranslateService.get('generic.emptyState.title')} description={TranslateService.get('generic.emptyState.description')} />
                                </div>
                            </div>
                        }

                        {
                            materials.filtered.map(m => (
                                <div className='col-span-8 col-start-3' key={m._id}>
                                    <div className='card flex '>
                                        <div style={{ backgroundImage: `url("${thumbnail(m)}")` }} className='bg-no-repeat bg-center bg-cover w-[200px] h-[117px]'> </div>
                                        <div className='ml-7 grow'>
                                            <div className='flex '>
                                                <div className='grow'>
                                                    <div className='flex items-center'>
                                                        <h1 className='heading-h6 !text-default underline uppercase mr-3 cursor-pointer' onClick={() => setCurrentMaterial({ isOpen: true, material: m })} >{m.titulo}</h1>
                                                        <label className='text-label-light-default bg-label-light-bg py-[2px] px-[6px] mr-3 whitespace-nowrap font-semibold leading-[14px] rounded-[100px] text-[10px] uppercase'>{formatType(m.tipo)}</label>
                                                    </div>                                                    
                                                </div>
                                                {
                                                    m.like && 
                                                    <div className='like' onClick={() => handleLike(m)}>
                                                        { m.like.status &&  <img src={LIKE} className=''  alt=""  /> }
                                                        { !m.like.status &&  <img src={NO_LIKE} className=''  alt="I like it" /> }
                                                        {/* <img src={LIKE}  className={ 'cursor-pointer w-[20px] ' + (isLiked === false ? 'hidden': '')}onClick={handleLike} alt="I like it"/>  */}
                                                    </div>
                                                }
                                                
                                            </div>
                                            <p className='text-secundary mb-3'>{moment(m.createdAt).format("DD/MM/YYYY")}</p>
                                            <p className='text-secundary'>{m.descripcion}</p>
                                        </div>
                                    </div>
                                </div>
                            ))
                        }


                    </div>
                </div>
            </div>
        </>
    );
}
